// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1RUrv","overflowing":"ReadFullNote_overflowing__1LBjm"};